<h1 mat-dialog-title style="font-size: x-large;text-align: center;">
  {{ 'TRIP.CANCEL.TITLE' | translate }}
</h1>

<div mat-dialog-content class="space-y-4 py-2">
  <p class="text-sm text-gray-500">
    {{ 'TRIP.CANCEL.DESCRIPTION' | translate }}
  </p>

  <mat-radio-group [(ngModel)]="selectedReason" class="flex flex-col gap-3">
    <div
      *ngFor="let reason of cancelReasons"
      class="border rounded-lg p-2 transition-all cursor-pointer"

      [ngClass]="{
        'border-[#e6a700] bg-[#e6a700]/5': selectedReason === reason.value,
        'border-gray-200': selectedReason !== reason.value
      }"
      (click)="selectedReason = reason.value"
    >
      <mat-radio-button
        [value]="reason.value"
        color="primary"
        class="text-[#e6a700]"
      >
        <span style="font-family: unset !important;font-weight:600" >{{ reason.label | translate }}</span>
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <div
    *ngIf="selectedReason === 'other'"
    [@slideInTop]
    class="mt-3"
  >
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ 'TRIP.CANCEL.OTHER_PLACEHOLDER' | translate }}</mat-label>
      <textarea
        matInput
        [(ngModel)]="customReason"
        placeholder="{{ 'TRIP.CANCEL.OTHER_PLACEHOLDER' | translate }}"
        rows="3"
        class="resize-none"
        [maxlength]="maxLength"
      ></textarea>
      <mat-hint align="end">{{ customReason.length }}/{{ maxLength }}</mat-hint>
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions class="flex justify-between gap-2 mt-4">
  <button
    mat-stroked-button
    color="primary"
    (click)="onCancel()"
    class="flex-1 sm:flex-none"
  >
    {{ 'COMMON.CANCEL' | translate }}
  </button>

  <button
    mat-flat-button
    color="primary"
    [disabled]="isConfirmDisabled"
    (click)="onConfirm()"
    class="bg-[#e6a700] hover:bg-[#cc9500] text-white flex-1 sm:flex-none disabled:opacity-50"
  >
    {{ 'COMMON.CONFIRM' | translate }}
  </button>
</div>
